import { Button, DatePicker, Form, Modal, Select } from "antd";
import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import dayjs from "dayjs";
import { EmployeeWeeklyEsicHistorySetup } from "../../../redux/rtk/features/employemntStatus/employmentStatusSlice";
import { loadSingleStaff } from "../../../redux/rtk/features/user/userSlice";

const WeeklyESICEditSinglePopup = ({ data, setLoading }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { id } = useParams();
  const { Option } = Select;

  useEffect(() => {
    if (isModalOpen && data) {
      form.setFieldsValue({
        IsEsicDeducted: data.IsEsicDeducted ? "Yes" : "No", // Convert boolean to Yes/No
        EffectedFrom: data.EffectedFrom ? dayjs(data.EffectedFrom) : null,
        EffectedTo: data.EffectedTo ? dayjs(data.EffectedTo) : null,

      });
    }
  }, [isModalOpen, data, form]);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    form.resetFields();
  };

   const onFinish = async (values) => {
      try {
        setLoading(true);
        const response = await dispatch(EmployeeWeeklyEsicHistorySetup({
          ...values,
          IsEsicDeducted: values.IsEsicDeducted === "Yes",
          EsicDeductedHistoryId: data.EsicDeductedHistoryId,
          EmployeeId: id,
          DataStatus: 1,
        }));
        if (response.payload.message === "success") {
          dispatch(loadSingleStaff(id));
          setIsModalOpen(false);
          form.resetFields();
        }
      } catch (error) {
        // console.error("Error adding ESIC history:", error);
      } finally {
        setLoading(false);
      }
    };

  return (
    <>
      <Button onClick={showModal} className="mr-2">
        Edit
      </Button>
      <Modal
        title="Edit ESIC Status"
        open={isModalOpen}
        onCancel={handleCancel}
        footer={null}
      >
        <Form
          form={form}
          name="editEsicStatus"
          layout="vertical"
          onFinish={onFinish}
        >
          <Form.Item
            label="ESIC Deducted"
            name="IsEsicDeducted"
            rules={[{ required: true, message: "Please select ESIC deduction status!" }]}
          >
            <Select placeholder="Select ESIC deduction status" allowClear>
              <Option value="Yes">Yes</Option>
              <Option value="No">No</Option>
            </Select>
          </Form.Item>
          <Form.Item
            label="Effective From"
            name="EffectedFrom"
            rules={[{ required: true, message: "Please enter the effective date!" }]}
          >
            <DatePicker />
          </Form.Item>
           <Form.Item
              label="Effective To"
              name="EffectedTo"
            >
              <DatePicker />
            </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit">
              Update
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default WeeklyESICEditSinglePopup;